// Получение id сделки из pathname
export function getDealIdFromPath() {
  const path = window.location.pathname;
  const segments = path.split('/');
  const id =
    segments[segments.length - 1] === ''
      ? segments[segments.length - 2]
      : segments[segments.length - 1];
  return id;
}
